import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Placeholder from 'components/consumer/Placeholder';
import RatingAndReviewsPlaceholder from 'components/consumer/RatingAndReviews/RatingAndReviewsPlaceholder';
import PDPPriceAndFinancePlaceholder from './PDPPriceAndFinancePlaceholder';
const PDPNameSectionPlaceholder = t0 => {
  const $ = _c(11);
  const {
    disableStickyPriceRow: t1,
    hideRatings: t2
  } = t0;
  const disableStickyPriceRow = t1 === undefined ? false : t1;
  const hideRatings = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-row items-center"><h1 className="text-xl font-bold text-gray md:text-2xl md:font-bold pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0 mb-1.5 md:mt-10"><Placeholder type="rect" loading={true} className="!w-full lg:!w-[310px]" style={{
          height: "23px"
        }} /></h1></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== hideRatings) {
    t4 = !hideRatings && <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0"><RatingAndReviewsPlaceholder /></div>;
    $[1] = hideRatings;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = !disableStickyPriceRow;
  let t6;
  if ($[3] !== t5) {
    t6 = classNames("bg-white pt-4 px-0 pb-3 lg:items-center lg:flex lg:justify-between lg:px-0 lg:py-5 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0", {
      "sticky top-0 z-[999] lg:z-[1001]": t5
    });
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PDPPriceAndFinancePlaceholder />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t6) {
    t8 = <div className={t6}>{t7}</div>;
    $[6] = t6;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t4 || $[9] !== t8) {
    t9 = <>{t3}{t4}{t8}</>;
    $[8] = t4;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
};
PDPNameSectionPlaceholder.propTypes = {
  disableStickyPriceRow: PropTypes.bool,
  hideRatings: PropTypes.bool
};
export default PDPNameSectionPlaceholder;